import { render } from "./PromptAddHeader.vue?vue&type=template&id=6cd11057"
import script from "./PromptAddHeader.vue?vue&type=script&lang=js"
export * from "./PromptAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__